var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhiteInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4732_7290",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 18,
    height: 18,
    fill: "#DDDDDD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4732_7290)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99609 15.4961C12.1382 15.4961 15.4961 12.1382 15.4961 7.99609C15.4961 3.85396 12.1382 0.496094 7.99609 0.496094C3.85396 0.496094 0.496094 3.85396 0.496094 7.99609C0.496094 12.1382 3.85396 15.4961 7.99609 15.4961ZM8.74463 4.24268C8.74463 4.65689 8.40884 4.99268 7.99463 4.99268C7.58042 4.99268 7.24463 4.65689 7.24463 4.24268C7.24463 3.82846 7.58042 3.49268 7.99463 3.49268C8.40884 3.49268 8.74463 3.82846 8.74463 4.24268ZM7.24463 7.24268C7.24463 6.82846 7.58042 6.49268 7.99463 6.49268C8.40884 6.49268 8.74463 6.82846 8.74463 7.24268V11.7427C8.74463 12.1569 8.40884 12.4927 7.99463 12.4927C7.58042 12.4927 7.24463 12.1569 7.24463 11.7427V7.24268Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteInfo);
export default ForwardRef;